(function(window) {
    window.UNantesAlerte = function() {
        var object = {
            setCookie: function(name, value, expire, path, domain) {
                document.cookie = name + ' = ' + encodeURIComponent(value) + '  ' +
                    ((expire === undefined) ? '' : ('; expires = ' + expire.toGMTString())) +
                    ((path === undefined) ? '' : ('; path = ' + path)) +
                    ((domain === undefined) ? '' : ('; domain = ' + domain));
            },
            getCookie: function(name) {
                if (document.cookie.length === 0) {
                    return null;
                }
                var regSepCookie = new RegExp('(; )', 'g');
                var cookies = document.cookie.split(regSepCookie);
                for (var i = 0; i < cookies.length; i++) {
                    var regInfo = new RegExp('=', 'g');
                    var infos = cookies[i].split(regInfo);
                    if (infos[0] === name) {
                        return decodeURIComponent(infos[1]);
                    }
                }
                return null;
            },
            encodeMessage: function(selector) {
                var element = document.querySelector(selector);
                if (!!element) {
                    return btoa(element.innerText.trim());
                }
                return '';
            },
            willAlertBeShown: function(message) {
                var cookieValue = this.getCookie('alerte');
                return !cookieValue || cookieValue !== message;
            },
            bind: function() {
                var self = this;
                // Si cookie absent ou expiré on affiche la popin
                window.addEventListener('modalloaded', function() {
                    var message = self.encodeMessage('[data-modal-unantes="alerte"] .modal__description');
                    if (self.willAlertBeShown(message)) {
                        var dtExpire = Date.now() + 3600 * 24 * 1000;
                        // expiration 24h
                        self.setCookie('alerte', message, new Date(dtExpire), '/');
                        var event = new CustomEvent('modal-unantes.open');
                        var modal = document.querySelector('[data-modal-unantes="alerte"]');
                        if (!!modal) {
                            modal.dispatchEvent(event);
                        }
                    }
                });
            },
            __construct: function() {}
        };
        object.__construct.call(object, arguments);
        return object;
    };

    var alertePopup = new UNantesAlerte();
    alertePopup.bind();
}(window));
